import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { PeriodCalendarComponent } from '@hglobal/fin-ui';

@Component({
  selector: 'iw-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      --fu-input-txt-uneditable: var(--fu-input-txt-filled);
    }
  `,
  imports: [PeriodCalendarComponent, ReactiveFormsModule],
})
export class DateRangePickerComponent {
  readonly control = input<FormControl>();
  readonly leftMonthToShowByDefault = input<Date>();
  readonly maxDate = input<Date>();
  readonly minDate = input<Date>();
  readonly label = input<string>();
  readonly placeholder = input<string>();
  readonly useOutlineLabel = input<boolean>();
}
